
import type { IGatsbyImageData } from 'gatsby-plugin-image';

import Image from '@klv/atoms/image';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/audienceCard.module.css';
import type { IAudienceCard } from './types';

const AudienceCard = ({ 
  className,
  backgroundColor = 'dark',
  titleAndUrl,
  image,
  $current,
  swipe,
  $index,
  $activeIndex,
  setThisSlide,
}: IAudienceCard) => {

  const clickHandler = (e: React.MouseEvent<HTMLDivElement> | undefined) => {
    /*
      On mobile only the swipe will not automatically follow the click
    */

    if ($current === undefined && window.matchMedia('(max-width: 768px)').matches) {
  
      e?.preventDefault();

      if ($index < $activeIndex) {
        swipe(-1);
      } else {
        swipe(1);
      }
    } else {
      if (titleAndUrl.openInNewTab) {
        window.open(titleAndUrl.url, '_blank');
      } else {
        window.location.href = titleAndUrl.url || '';
      }
    }
  };

  const handleKeyUp = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (
      event.code === 'Space'
      || event.code === 'Enter'
    ) {
      event.preventDefault();
      clickHandler(undefined);
    }
  };

  return (
    <div className={generateClassName([styles.audienceCard, styles[backgroundColor], className])}
      aria-label={titleAndUrl?.openInNewTab ? `${titleAndUrl?.title} (opens in a new tab)` : titleAndUrl?.title}
      onClick={clickHandler}
      onFocus={() => {setThisSlide($index);}}
      onKeyUp={handleKeyUp}
      data-audience-card
      tabIndex={0}
    >
      <div className={styles.imageContainer}>
        <Image
          className={styles.image}
          imageData={image?.gatsbyImage as IGatsbyImageData}
          altText={image?.altText}
        />
      </div>
      <div className={styles.textContainer}>
        <div className={styles.text}>
          {titleAndUrl.title}
        </div>
        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.5 9.5L17.6635 9.5M9.92308 1.42308L18 9.5L9.92308 17.5769" strokeWidth="2"/>
        </svg>
      </div>
    </div>
  );
};

export default AudienceCard;
